import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Mail} from '../../model/mail';

export class MailForm {

  static getForm(mail?: Mail): FormGroup {
    const controls = {};
    // @ts-ignore
    controls[MailForm.FIELDS.MAIL] = new FormControl('', [Validators.maxLength(100), Validators.required, Validators.email]);

    return new FormGroup(controls);
  }

  static getValue(mailForm?: FormGroup): Mail {
    const mail = new Mail();
    if (mailForm != null && mailForm.contains(MailForm.FIELDS.MAIL)) {
      // @ts-ignore
      mail.mail = mailForm.get(MailForm.FIELDS.MAIL).value;
    }

    return mail;
  }
}

export module MailForm {
  export enum FIELDS {
    MAIL = 'mail'
  }
}

